import { apiWithOffline } from './api';
import localDB from './localDB';

export const clientsService = {
  getAll: async (params = {}) => {
    try {
      const response = await apiWithOffline.get('/clients', { params });
      // Убеждаемся, что возвращаем данные в правильном формате
      if (response && response.data) {
        return Array.isArray(response.data) ? { data: response.data } : response.data;
      }
      if (Array.isArray(response)) {
        return { data: response };
      }
      return response || { data: [] };
    } catch (error) {
      // Если ошибка и мы в оффлайн режиме, получаем из локальной БД
      if (error.message && (error.message.includes('offline') || error.message.includes('No data'))) {
        try {
          const clients = await localDB.getClients();
          return Array.isArray(clients) ? { data: clients } : { data: [] };
        } catch (dbError) {
          return { data: [] };
        }
      }
      throw error;
    }
  },

  create: async (data) => {
    const response = await apiWithOffline.post('/clients', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await apiWithOffline.put(`/clients/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiWithOffline.delete(`/clients/${id}`);
    return response.data;
  },

  exportCsv: async () => {
    const response = await apiWithOffline.get('/clients/export.csv', { responseType: 'blob' });
    return response.data;
  },

  importClients: async (clients) => {
    const response = await apiWithOffline.post('/clients/import', { clients });
    return response.data;
  },
};
